module.exports = __webpack_public_path__ + "img/p2-41.f0b18a72.png";